import { render, staticRenderFns } from "./hospitalRoom.vue?vue&type=template&id=46ca5f6f&"
import script from "./hospitalRoom.vue?vue&type=script&lang=js&"
export * from "./hospitalRoom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports